module.exports = __webpack_public_path__ + "assets/063818a677532744ab9d092535d845b8.mp3";